import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const StyledContainer = styled.div`
  display: flex;
  padding: 16px 0;
  gap: 16px;
  height: fit-content;
`

export const StyledLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledTitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2px;
`

export const StyledIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  height: 22px;
  margin-left: 4px;
`

export const StyledInfo = styled.div`
  display: flex;
  align-items: flex-end;
`

export const StyledCount = styled.span.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.overview.count
})`
  font-weight: ${sys.fontWeight.semibold};
  font-size: ${sys.typescale[20].size};
  line-height: ${sys.typescale[20].lineHeight};
`

export const StyledPercent = styled.span.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.overview.percentOfTotal
})`
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[12].size};
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

export const StyledRight = styled.div`
  flex: 1;
  margin-right: -6px;
`

export const Emphasized = styled.span`
  font-weight: ${sys.fontWeight.semibold};
`
